__turbopack_context__.v({
  "description": "download-module__-Fq3Iq__description",
  "hero": "download-module__-Fq3Iq__hero",
  "note": "download-module__-Fq3Iq__note",
  "page": "download-module__-Fq3Iq__page",
  "qrCard": "download-module__-Fq3Iq__qrCard",
  "qrFrame": "download-module__-Fq3Iq__qrFrame",
  "qrHint": "download-module__-Fq3Iq__qrHint",
  "step": "download-module__-Fq3Iq__step",
  "steps": "download-module__-Fq3Iq__steps",
  "tag": "download-module__-Fq3Iq__tag",
  "textBlock": "download-module__-Fq3Iq__textBlock",
  "title": "download-module__-Fq3Iq__title",
});
